export const DREAM_CASINO='api/dreamcasino/load-game/';
export const GET_LIVE_POCKER_URL='api/get-live-poker-url/';
export const MAKE_FAVOURITE = 'api/make-match-favorite';
export const GET_FAVOURITE_LIST = 'api/favorite-list';